module.exports = __webpack_public_path__ + "img/air-4.a98a53f9.jpeg";